<div class="col col-md-8 mt-3">
  <div class="card">

  <div class="card-header d-flex flex-row">
    <button mat-mini-fab color="warn" [routerLink]="['/']"><mat-icon>arrow_back</mat-icon></button>
    <h1 class="ms-3 mt-1" i18n>Ďalšie informácie, položky štúdia</h1>
  </div>

  <div class="card-body">

    <div>
      <div class="h3">
        {{studium.studijnyProgram.skratka}} - {{studium.studijnyProgram.popis}},
        {{studium.zapisneListy[0].rocnik}}. <span i18n>ročník</span>
      </div>
      <hr>
      <div class="d-flex flex-wrap justify-content-between">
        <a class="kontrola dropdown-toggle" [matMenuTriggerFor]="menu"><span i18n>Kontroly</span></a>
        <a class="kontrola" (click)="openMobilityApp()"><span i18n>Mobility</span></a>
        <a class="kontrola" (click)="openSkolnePoplatkyApp()"><span i18n>Školné a poplatky</span></a>
        <a class="kontrola" (click)="openStipendiaApp()"><span i18n>Štipendiá</span></a>
        <a class="kontrola" (click)="openUdelovanieSuhlasovApp()"><span i18n>Udeľovanie súhlasov</span></a>
      </div>
      <hr>
    </div>

    <div *ngIf="studium.poznamky.length" class="p-3 m-3 blok">
      <div class="h6" i18n>Poznámky</div>
      <ul class="small">
        <li *ngFor="let p of studium.poznamky; let last = last;">
          {{p.datum|date}}: {{p.popis}}
          <br/>{{p.poznamka}}
          <br *ngIf="!last"/><br *ngIf="!last"/>
        </li>
      </ul>
    </div>

    <div *ngIf="studium.prestupy.length" class="p-3 m-3 blok">
      <div class="h6" i18n>Prestupy</div>
      <ul class="small">
        <li *ngFor="let p of studium.prestupy; let last = last;">
          {{p.datum|date}} <span i18n>do</span> {{p.doRocnika}} <span i18n>ročníka</span>
          <div *ngIf="p.kodSposUkon"><span i18n>spôsob ukončenia</span>: {{p.kodSposUkon}}</div>
          <div *ngIf="p.studijnyProgram">{{p.studijnyProgram.skratka}} - {{p.studijnyProgram.popis}}</div>
          <br *ngIf="!last"/><br *ngIf="!last"/>
        </li>
      </ul>
    </div>

    <div *ngIf="studium.prerusenia.length" class="p-3 m-3 blok">
      <div class="h6" i18n>Prerušenia</div>
      <ul class="small">
        <li *ngFor="let p of studium.prerusenia; let last = last;">
          <span i18n>od</span> {{p.zaciatok|date}} <span i18n>do</span> {{p.koniec|date}}
          <div *ngIf="p.rocnik">{{p.rocnik}} <span i18n>ročník</span></div>
          <br/>{{p.dovod}}
          <br *ngIf="!last"/><br *ngIf="!last"/>
        </li>
      </ul>
    </div>

    <div *ngIf="studium.popisy.length">
      <div class="h6" i18n>Doplňujúci popis</div>
      <ul class="small">
        <li *ngFor="let p of studium.popisy; let last = last;">
          {{p.text}}
          <br/>{{p.popis}}
          <br *ngIf="!last"/><br *ngIf="!last"/>
        </li>
      </ul>
    </div>

  </div>

  <mat-menu #menu="matMenu">

    <button mat-menu-item class="small" (click)="openKomplexnaKontrolaApp()">
      <mat-icon>fiber_manual_record</mat-icon>
      <span i18n>Komplexná kontrola</span>
    </button>

    <button mat-menu-item class="small" (click)="openPovinnePredmetyApp()">
      <mat-icon>fiber_manual_record</mat-icon>
      <span i18n>Povinné predmety</span>
    </button>

    <button mat-menu-item class="small" (click)="openNeuspesneZapisyApp()">
      <mat-icon>fiber_manual_record</mat-icon>
      <span i18n>Neúspešné zápisy predmetov</span>
    </button>

    <button mat-menu-item class="small" (click)="openAbsolvovaniePredmetovApp()">
      <mat-icon>fiber_manual_record</mat-icon>
      <span i18n>Absolvovanie predmetov</span>
    </button>

    <button mat-menu-item class="small" (click)="openZiskaneKredityApp()">
      <mat-icon>fiber_manual_record</mat-icon>
      <span i18n>Získané kredity</span>
    </button>

    <button mat-menu-item class="small" (click)="openPredpisanaSkladbaApp()">
      <mat-icon>fiber_manual_record</mat-icon>
      <span i18n>Predpísaná skladba</span>
    </button>

  </mat-menu>

</div>
</div>
